// 工具类
import API from 'src/common/api';
import store from 'src/store';
import * as utils from 'src/store/utils';

function VENDOR_ADMITTANCE_ENUM(params) {
	return new Promise((resolve, reject) => {
		if(!params.typeCode) {
			resolve([])
		} else {
			API.baseCommon.POST_SPS_SYS_ENUM_URL(params)
				.done(res => {
					const array = res.data.map(item => {
						return {
							code: item.valueCode,
							comment: item.valueDesc
						}
					})
					resolve(array)
				})
				.fail(err => {
					reject([])
				})
		}
	})
}
// 枚举值查询的方法
const methods = {
	POST_SPS_SYS_ENUM_URL(params) {
		if (!utils.isArray(params)) {
			return VENDOR_ADMITTANCE_ENUM(params) 
		} else {
			const promise_list = params.map(item => VENDOR_ADMITTANCE_ENUM(item));
			return Promise.all(promise_list)
				.then(arg => {
					return arg.reduce((pre, next) => {
						return pre.concat(next);
					}, [])
				})
				.catch(err => {
				})
		}
	},
	POST_TECH_RECORD_LIST(params) {
		return new Promise((resolve, reject) => {
			API.autoAPi.POST_TECH_RECORD_LIST()
				.done(res => {
					if (res.data.length <= 0) return [];
					const array = res.data.map(item => ({
						comment: item.materialDesc,
						code: item.recordNo,
						source: item
					}));
					resolve(array)
				})
				.fail(err => {
					reject([])
				})
		})
	},
	POST_COMPANY_FIND_LIST(params) {
		return new Promise((resolve, reject) => {
			if(params.brandCode == 6 && params.specialM60) {
				params.isProducingCompany = null
			}
			API.autoAPi.POST_COMPANY_FIND_LIST(params)
				.done(res => {
					if (res.data.length <= 0) return [];
					const array = res.data.map((item, index) => ({
						comment: item.companyName,
						code: item.companyCode,
						source: item
					}));
					resolve(array)
				})
				.fail(err => {
					reject([])
				})
		})
	},
	POST_SYS_GET_MATERIAL_CATEGORY_LIST(params) {
		return new Promise((resolve, reject) => {
			API.autoAPi.POST_SYS_GET_MATERIAL_CATEGORY_LIST(params)
				.done(res => {
					if (res.data.length <= 0) return [];
					const array = res.data.map(item => ({
						comment: item.categoryDesc,
						code: item.categoryCode,
						source: item
					}));
					resolve(array)
				})
				.fail(err => {
					reject([])
				})
		})
	},
	POST_STORAGE_FIND_LIST(params) {
		params.storageLike = params.query
		return new Promise((resolve, reject) => {
			API.autoAPi.POST_STORAGE_FIND_LIST(params)
				.done(res => {
					if (res.data.length <= 0) return [];
					const array = res.data.map((item, index) => ({
						comment: item.storageDesc,
						code: item.storageCode,
						source: item
					}));
					resolve(array)
				})
				.fail(err => {
					reject([])
				})
		})
	},
	DIMENSION_GROUP_URL(params) {
		return new Promise((resolve, reject) => {
			API.baseCommon.DIMENSION_GROUP_URL({
				featureType: params.id
			})
				.done(res => {
					if (res.data.length <= 0) return [];
					const array = res.data.map(item => ({
						comment: item.featureDesc,
						code: item.featureCode
					}));
					resolve(array)
				})
				.fail(err => {
					reject([])
				})
		})
	},
	POST_MASTER_DATA_ENUM_FEATURE_PAGE(params) {
		if(!params.featureCode) return []
		let _params = {
				deleteFlag: 0,
				featureType: params.featureType,
				pageNo: 1,
				pageSize: 9999,
				...params
		}
		return new Promise((resolve, reject) => {
			API.autoAPi.POST_MASTER_DATA_FEATURE_PAGE(_params)
				.done(res => {
					if (res.data.records.length <= 0) return [];
					const array = res.data.records.map((item,index) => ({
						comment: item.featureValueDesc + `(${item.featureValueCode})`,
						code: item.featureValueCode,
						source: item
					}));
					resolve(array)
				})
				.fail(err => {
					reject([])
				})
		})
	},
	POST_SYS_ALL_MATERIAL_CATEGORY_LIST(params) {
		return new Promise(async (resolve, reject) => {
			try {
				let v001Data = await syncGetEnum('POST_SPS_SYS_ENUM_URL', { typeCode: 'VendorProductionCategory' })
				let v003Data = await syncGetEnum('POST_SPS_SYS_ENUM_URL', { typeCode: 'VendorProductionCategoryM1' })
				resolve([...v001Data, ...v003Data])
			} catch (error) {
				reject([])
			}
		})
	},
	VENDORMASTER(params) {
		return new Promise((resolve, reject) => {
			API.baseCommon.VENDORMASTER({
						vendorLike: params.query,
				})
				.done(res => {
						if (!res.data || !res.data.records || res.data.records.length <= 0) return [];
						const array = res.data.records.map(item => ({
								comment: item.vendorName,
								code: item.vendorCode,
								source: item
						}));
						resolve(array)
				})
				.fail(err => {
						reject([])
				})
		})
},
POST_AD_PNODE_MODEL_LIST(params) {
	return new Promise((resolve, reject) => {
		API.autoAPi.POST_AD_PNODE_MODEL_LIST(params)
			.done(res => {
				if (res.data.length <= 0) return [];
				const array = res.data.map(item => ({
					comment: item.pnodeName,
					code: item.pnodeCode,
					source: item
				}));
				resolve(array)
			})
			.fail(err => {
				reject([])
			})
	})
},
	// VENDOR_ADMITTANCE_ENUM(params) {
	// 	if (!utils.isArray(params)) {
	// 		return VENDOR_ADMITTANCE_ENUM(params);
	// 	}
	// 	const promise_list = params.map(item => VENDOR_ADMITTANCE_ENUM(item));
	// 	return Promise.all(promise_list)
	// 		.then(arg => {
	// 			return arg.reduce((pre, next) => {
	// 				return pre.concat(next);
	// 			}, [])
	// 		})
	// 		.catch(err => {
	// 		})
	// },
	// GET_COMMON_USR_BRAND() {
	// 	return new Promise((resolve, reject) => {
	// 		API.autoAPi.GET_COMMON_USR_BRAND()
	// 			.done(res => {
	// 				if (res.list.length <= 0) return [];
	// 				const array = res.list[0].enumValue.map(item => {
	// 					return {
	// 						code: item.valueCode,
	// 						comment: item.valueDesc,
	// 						source: item
	// 					}
	// 				})

	// 				resolve(array)
	// 			})
	// 			.fail(err => {
	// 				reject([])
	// 			})
	// 	})
	// },
	// VENDOR_ADMITTANCE_SUPERIOR_CLASS(params) {
	// 	return new Promise((resolve, reject) => {
	// 		API.DeclarationInfo.VENDOR_ADMITTANCE_SUPERIOR_CLASS(params)
	// 			.done(res => {
	// 				const array = res.list.map(setRootList);
	// 				resolve(array)

	// 				function setRootList(item) {
	// 					return {
	// 						value: item.largeClassCode,
	// 						label: item.largeClassName,
	// 						children: item.items.map(setChildren)
	// 					}
	// 				}

	// 				function setChildren(item) {
	// 					return {
	// 						label: item.smallClassName,
	// 						value: item.smallClassCode
	// 					}
	// 				}
	// 			})
	// 			.fail(err => {
	// 				reject([])
	// 			})
	// 	})
	// },
	// VENDOR_ADMITTANCE_SUPERIOR_CLASS_LIST(params) {
	// 	return new Promise((resolve, reject) => {
	// 		API.DeclarationInfo.VENDOR_ADMITTANCE_SUPERIOR_CLASS(params)
	// 			.done(res => {
	// 				const array = res.list.reduce(setRootList, []);
	// 				resolve(array)

	// 				function setRootList(pre, next) {
	// 					pre.concat(next.items.map(setChildren))
	// 					return pre;
	// 				}

	// 				function setChildren(item) {
	// 					return {
	// 						label: item.smallClassName,
	// 						value: item.smallClassCode
	// 					}
	// 				}
	// 			})
	// 			.fail(err => {
	// 				reject([])
	// 			})
	// 	})
	// },
	// EVALUATION_LOG_ARCHIVE_LIST(params) {
	// 	return new Promise((resolve, reject) => {
	// 		API.selfevaluation.EVALUATION_LOG_ARCHIVE_LIST(params)
	// 			.done(res => {
	// 				const array = res.list.map(setChildren, []);
	// 				resolve(array)

	// 				function setChildren(item) {
	// 					return {
	// 						comment: item.evaluationName,
	// 						code: item.evaluationName
	// 					}
	// 				}
	// 			})
	// 			.fail(err => {
	// 				reject([])
	// 			})
	// 	})
	// },
	// DIMENSION_DETAIL_URL(params) {
	// 	return new Promise((resolve, reject) => {
	// 		API.baseCommon.DIMENSION_DETAIL_URL(params)
	// 			.done(res => {
	// 				if (res.list.length <= 0) return [];
	// 				const array = res.list[0].featureDetails.map(setChildren);
	// 				resolve(array)
	// 				function setChildren(item) {
	// 					return {
	// 						comment: item.featureValueDesc,
	// 						code: item.featureValueCode,
	// 						type: item.deleteFlag
	// 					}
	// 				}
	// 			})
	// 			.fail(err => {
	// 				reject([])
	// 			})
	// 	})
	// },
	// VENDORQUOTEDFOB_QUOTEDATTR_LIST(params) {
	// 	return new Promise((resolve, reject) => {
	// 		API.baseCommon.VENDORQUOTEDFOB_QUOTEDATTR_LIST(params)
	// 			.done(res => {
	// 				const array = res.list.map(setChildren, []);
	// 				resolve(array)

	// 				function setChildren(item) {
	// 					return {
	// 						comment: item.name,
	// 						code: item.code
	// 					}
	// 				}
	// 			})
	// 			.fail(err => {
	// 				reject([])
	// 			})
	// 	})
	// },
	// DEVELOPERPRICING_COLOR_LIST(params) {
	// 	return new Promise((resolve, reject) => {
	// 		API.baseCommon.DEVELOPERPRICING_COLOR_LIST(params)
	// 			.done(res => {
	// 				const array = res.list.map(setChildren, []);
	// 				resolve(array)

	// 				function setChildren(item) {
	// 					return {
	// 						comment: item.colorName,
	// 						code: item.colorCode
	// 					}
	// 				}
	// 			})
	// 			.fail(err => {
	// 				reject([])
	// 			})
	// 	})
	// },
	// POST_MRP_PO_SELECTSIZE(params) {
	// 	return new Promise((resolve, reject) => {
	// 		API.autoAPi.POST_MRP_PO_SELECTSIZE(params)
	// 			.done(res => {
	// 				const array = res.list.map(setChildren, []);
	// 				resolve(array)

	// 				function setChildren(item, i) {
	// 					return {
	// 						comment: item.colorDesc,
	// 						code: item.colorCode,
	// 						list: item.list.map(_item => {
	// 							return {
	// 								code: _item.sizeCode,
	// 								comment: _item.sizeDesc
	// 							}
	// 						})
	// 					}
	// 				}
	// 			})
	// 			.fail(err => {
	// 				reject([])
	// 			})
	// 	})
	// },
	// POST_SUPPLIER_GET_CONFIG_BIG_CLASS(params) {
	// 	return new Promise((resolve, reject) => {
	// 		API.autoAPi.POST_SUPPLIER_GET_CONFIG_BIG_CLASS(params)
	// 			.done(res => {
	// 				if (res.data) {
	// 					const array = res.data
	// 					resolve(array)
	// 				}

	// 			})
	// 			.fail(err => {
	// 				reject([])
	// 			})
	// 	})
	// },
	// POST_COMPANY_FIND_LIST(params) {
	// 	return new Promise((resolve, reject) => {
	// 		API.autoAPi.POST_COMPANY_FIND_LIST(params)
	// 			.done(res => {
	// 				if (res.data.length <= 0) return [];
	// 				const array = res.data.map((item, index) => ({
	// 					comment: item.companyName,
	// 					code: item.companyCode,
	// 					source: item
	// 				}));
	// 				resolve(array)
	// 			})
	// 			.fail(err => {
	// 				reject([])
	// 			})
	// 	})
	// },
	// DIMENSION_GROUP_URL(params) {
	// 	return new Promise((resolve, reject) => {
	// 		API.baseCommon.DIMENSION_GROUP_URL({
	// 			colorCode: params.query,
	// 			...params
	// 		})
	// 			.done(res => {
	// 				if (res.list.length <= 0) return [];
	// 				const array = res.list.map(item => ({
	// 					comment: item.featureDesc,
	// 					code: item.featureCode
	// 				}));
	// 				resolve(array)
	// 			})
	// 			.fail(err => {
	// 				reject([])
	// 			})
	// 	})
	// },
	// POST_APPOINT_STORAGE_USABLE_LIST(params) {
	// 	return new Promise((resolve, reject) => {
	// 		API.autoAPi.POST_APPOINT_STORAGE_USABLE_LIST({
	// 			...params
	// 		})
	// 			.done(res => {
	// 				if (res.list.length <= 0) return [];
	// 				const array = res.list.map(item => ({
	// 					comment: item.storageName,
	// 					code: item.id
	// 				}));
	// 				resolve(array)
	// 			})
	// 			.fail(err => {
	// 				reject([])
	// 			})
	// 	})
	// },
	// POST_SALES_ALLOCATE_STOCKADDRESS(params) {
	// 	return new Promise((resolve, reject) => {
	// 		API.autoAPi.POST_SALES_ALLOCATE_STOCKADDRESS({
	// 			...params
	// 		})
	// 			.done(res => {
	// 				if (res.list.length <= 0) return [];
	// 				const array = res.list.map(item => ({
	// 					comment: item.comment,
	// 					code: item.code
	// 				}));
	// 				resolve(array)
	// 			})
	// 			.fail(err => {
	// 				reject([])
	// 			})
	// 	})
	// },
	// POST_APPOINT_STORAGE_LIST(params) {
	// 	return new Promise((resolve, reject) => {
	// 		API.autoAPi.POST_APPOINT_STORAGE_LIST({
	// 			...params
	// 		})
	// 			.done(res => {
	// 				if (res.list.length <= 0) return [];
	// 				const array = res.list.map(item => ({
	// 					comment: item.storageName,
	// 					code: item.id
	// 				}));
	// 				resolve(array)
	// 			})
	// 			.fail(err => {
	// 				reject([])
	// 			})
	// 	})
	// },
	// POST_APPOINT_STORAGE_LIST(params) {
	// 	return new Promise((resolve, reject) => {
	// 		API.autoAPi.POST_APPOINT_STORAGE_LIST({
	// 		})
	// 			.done(res => {
	// 				if (res.list.length <= 0) return [];
	// 				const array = res.list.map(item => ({
	// 					comment: item.storageName,
	// 					code: item.id
	// 				}));
	// 				resolve(array)
	// 			})
	// 			.fail(err => {
	// 				reject([])
	// 			})
	// 	})
	// },
	// POST_STORAGE_FIND_LIST(params) {
	// 	params.storageLike = params.query
	// 	return new Promise((resolve, reject) => {
	// 		API.autoAPi.POST_STORAGE_FIND_LIST(params)
	// 			.done(res => {
	// 				if (res.data.length <= 0) return [];
	// 				const array = res.data.map((item, index) => ({
	// 					comment: item.storageDesc,
	// 					code: item.storageCode,
	// 					source: item
	// 				}));
	// 				resolve(array)
	// 			})
	// 			.fail(err => {
	// 				reject([])
	// 			})
	// 	})
	// },
	// POST_SYSTEM_ENUM_FUZZYVALUE(params) {
	// 	return new Promise((resolve, reject) => {
	// 		API.autoAPi.POST_SYSTEM_ENUM_FUZZYVALUE({
	// 			valueDesc: params.valueDesc,
	// 			typeCode: params.typeCode
	// 		})
	// 			.done(res => {
	// 				if (res.list.length <= 0) return [];
	// 				const array = res.list.map(item => ({
	// 					comment: item.valueDesc,
	// 					code: item.valueCode,
	// 					source: item
	// 				}));
	// 				resolve(array)
	// 			})
	// 			.fail(err => {
	// 				reject([])
	// 			})
	// 	})
	// },
	// getSystemEnum(params) {
	// 	return new Promise((resolve, reject) => {
	// 		API.baseCommon.getSystemEnum({ ...params })
	// 			.done(res => {
	// 				if (res.list.length <= 0) return [];
	// 				const array = res.list[0].enumValue.map(item => {
	// 					return {
	// 						code: item.valueCode,
	// 						comment: item.valueDesc,
	// 						source: item
	// 					}
	// 				})

	// 				resolve(array)
	// 			})
	// 			.fail(err => {
	// 				reject([])
	// 			})
	// 	})
	// },
	// POST_SUPPLIER_CONFIG(params) {
	// 	return new Promise((resolve, reject) => {
	// 		API.autoAPi.POST_SUPPLIER_CONFIG({
	// 			...params
	// 		})
	// 			.done(res => {
	// 				if (res.data.length <= 0) return [];
	// 				const array = res.data.map((item, index) => ({
	// 					comment: `${item.configNo} - ${item.configName}`,
	// 					code: item.configNo,
	// 					source: item
	// 				}));
	// 				resolve(array)
	// 			})
	// 			.fail(err => {
	// 				reject([])
	// 			})
	// 	})
	// },
	// POST_SYS_GET_MATERIAL_CATEGORY_LIST(params) {
	// 	return new Promise((resolve, reject) => {
	// 		API.autoAPi.POST_SYS_GET_MATERIAL_CATEGORY_LIST(params)
	// 			.done(res => {
	// 				if (res.data.length <= 0) return [];
	// 				const array = res.data.map(item => ({
	// 					comment: item.categoryDesc,
	// 					code: item.categoryCode,
	// 					source: item
	// 				}));
	// 				resolve(array)
	// 			})
	// 			.fail(err => {
	// 				reject([])
	// 			})
	// 	})
	// },
	// POST_QC_COMPLAINT_GETSTATUSLIST() {
	// 	return new Promise((resolve, reject) => {
	// 		API.autoAPi.POST_QC_COMPLAINT_GETSTATUSLIST()
	// 			.done(res => {
	// 				if (res.list.length <= 0) return [];
	// 				const array = res.list.map((item, index) => ({
	// 					comment: item.name,
	// 					code: item.value,
	// 					source: item
	// 				}));
	// 				resolve(array)
	// 			})
	// 			.fail(err => {
	// 				reject([])
	// 			})
	// 	})
	// },
	// POST_INVOICE_SCMPREINVOICEHEADER_GETSTATUSLIST() {
	// 	return new Promise((resolve, reject) => {
	// 		API.autoAPi.POST_INVOICE_SCMPREINVOICEHEADER_GETSTATUSLIST()
	// 			.done(res => {
	// 				if (res.data.length <= 0) return [];
	// 				const array = res.data.map((item, index) => ({
	// 					comment: item.name,
	// 					code: item.value,
	// 					source: item
	// 				}));
	// 				resolve(array)
	// 			})
	// 			.fail(err => {
	// 				reject([])
	// 			})
	// 	})
	// },
	// POST_SPSBOX_SELECTBOX(params) {
	// 	return new Promise((resolve, reject) => {
	// 		API.autoAPi.POST_SPSBOX_SELECTBOX({
	// 			...params,
	// 			cancelFlag: false
	// 		})
	// 			.done(res => {
	// 				if (res.list.length <= 0) return [];
	// 				const array = res.list.map(item => ({
	// 					comment: item.specName,
	// 					code: item.id
	// 				}));
	// 				resolve(array)
	// 			})
	// 			.fail(err => {
	// 				reject([])
	// 			})
	// 	})
	// },
	// GET_STORAGE_LIST({ brand }) {
	// 	const array = []
	// 	return new Promise((resolve, reject) => {
	// 		if (!brand) {
	// 			resolve([])
	// 			return
	// 		};
	// 		let url = conf.STORAGE_LIST_QUERY_URL + brand
	// 		Vue.http.get(url).then(response => {
	// 			if (response.body.list && response.body.list.length) {
	// 				response.body.list.forEach((item) => {
	// 					array.push({
	// 						comment: item.storageDesc,
	// 						code: item.storageCode,
	// 						source: item
	// 					})
	// 				})
	// 			}
	// 			resolve(array)
	// 		}).catch(err => {
	// 			reject([])
	// 		})
	// 	})
	// },
	// POST_SCMSTOREINDETAIL_GETSAPPONUMBER(params) {
	// 	return new Promise((resolve, reject) => {
	// 		API.storeIn.POST_SCMSTOREINDETAIL_GETSAPPONUMBER({
	// 			...params,
	// 			cancelFlag: false
	// 		})
	// 			.done(res => {
	// 				if (!res.data || !res.data.length) return [];
	// 				const array = res.data.map(item => ({
	// 					comment: item && item.scmPoNumber,
	// 					code: item && item.scmPoNumber
	// 				}));
	// 				resolve(array)
	// 			})
	// 			.fail(err => {
	// 				reject([])
	// 			})
	// 	})
	// },
	// POST_INTYPE(params) {
	// 	return new Promise((resolve, reject) => {
	// 		API.storeIn.POST_INTYPE(params)
	// 			.done(res => {
	// 				if (!res.list || !res.list.length) return [];
	// 				const array = res.list[0].enumValue.map(item => ({
	// 					comment: item && item.valueDesc,
	// 					code: item && item.valueCode
	// 				}));
	// 				resolve(array)
	// 			})
	// 			.fail(err => {
	// 				reject([])
	// 			})
	// 	})
	// },
}

// 搜索查询的方法
// 枚举Promise结果保存
const promiseKey = {};

// 如果已经保存了Enum 则取缓存好的
// 如果第一次请求 保存此Promise 并且返回此Promise 如果非第一次请求 返回缓存的Promise结果
export function setKeys(apiName, params) {
	const paramsMap = Object.keys(params);
	let key;
	if (paramsMap.length > 0) {
		key = paramsMap.reduce((pre, next) => {
			return `${pre}-${params[next]}`
		}, apiName)
	}
	else {
		key = apiName;
	}
	return key
}

export function getEnum(key) {
	return store.getters['mods/getEnum'][key];
}

export function syncGetEnum(apiName, params) {
	let key = setKeys(apiName, params)
	// const paramsMap = Object.keys(params);
	// let key;
	// if (paramsMap.length > 0) {
	//     key = paramsMap.reduce((pre, next) => {
	//         return `${pre}-${params[next]}`
	//     }, apiName)
	// }
	// else {
	//     key = apiName;
	// }
	const getEnumKey = store.getters['mods/getEnum'][key];
	if (params.cache !== false) {
		if (getEnumKey) {
			return Promise.resolve(getEnumKey);
		}
		if (promiseKey[key]) {
			return promiseKey[key]
		}
	}
	promiseKey[key] = methods[apiName](params).then(handleSetEnum)
	return promiseKey[key];

	function handleSetEnum(array) {
		store.commit('mods/setEnumValue', {
			array: array,
			key: `${apiName}-${params.code}`
		})
		return array;
	}
}


